import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Helper to strip HTML tags for excerpt
const getExcerpt = (htmlString, maxLength = 120) => {
  if (!htmlString) return '';
  const stripped = htmlString.replace(/<[^>]+>/g, ' ');
  if (stripped.length <= maxLength) return stripped;
  return stripped.substring(0, maxLength).trim() + '...';
};

export default function ServiceCard({ service }) {
  const { title, description, image, service_slug } = service;
  const imageUrl = Array.isArray(image) ? image[0] : image;

  return (
    <div className="bg-white border border-neutral-200 rounded-sm overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col group">
      {/* Image Container */}
      <div className="relative h-56 overflow-hidden bg-neutral-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="p-6 flex-grow flex flex-col">
        <div className="w-12 h-1 bg-red-700 mb-4" />
        <h3 className="text-xl font-bold text-neutral-950 mb-2 group-hover:text-red-700 transition-colors">
          {title}
        </h3>
        <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-grow">
          {getExcerpt(description)}
        </p>
        <Link
          to={`/ydelser/${service_slug}`}
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-neutral-950 hover:text-red-700 transition-colors mt-auto"
        >
          <span>Læs mere om ydelsen</span>
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
}
